<div class="modal-header">
  <h3 class="modal-title">{{itemInfo.HeadingText}}</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-6">
      <label class="control-label fw">Select Library</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedLibraryId" (change)="changeLibrary()">
        <option *ngFor="let item of regulationLibrary" value="{{item.id}}">{{ item.libraryName }}</option>
      </select>
    </div>
    <div class="col-lg-4">
      <label class="control-label fw">{{itemInfo.BodyText}}</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="itemInfo.BodyInput" />
      <div class="mb-2 fg-g-red">
        <small *ngIf="isErrorMsg">{{itemInfo.AlertMsg}}</small>
      </div>
    </div>
    <div class="col-lg-2 pt-4">
      <button class="btn btn-sm bg-g-lightGreen" (click)="onConfirmClick()"
        cdkFocusInitial>{{itemInfo.ActionButtonText}}</button>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-lg-6">
      <label class="control-label fw">Select Library</label>
      <select class="form-control form-control-sm" [(ngModel)]="prevOrder">
        <option *ngFor="let item of regulationLibrary" value="{{item.id}}">{{ item.libraryName }}</option>
      </select>
    </div>
    <div class="col-lg-4">
      <label class="control-label fw">Select Order</label>
      <select class="form-control form-control-sm" [(ngModel)]="newOrder">
        <option *ngFor="let item of regulationLibrary; let i = index" value="{{i+1}}">{{ i+1 }}</option>
      </select>
    </div>
    <div class="col-lg-2 pt-4">
      <button class="btn btn-sm bg-g-lightGreen" (click)="updateLibraryOrder()" cdkFocusInitial>Save
        <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm bg-g-red" [mat-dialog-close]="">Cancel</button>
</div>
